export class LivechatRequestFields {
  Question ="General Information";
    Username?:String;
    email?:String;
    phone?:String;
    firstName?:String;
    lastName?:String;
    searchType?:string;
}
